<template>
  <f7-link href="/settings" class="user-time">
    {{ time }}
  </f7-link>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'UserTime',

  data() {
    return {
      date: new Date()
    };
  },

  computed: {
    time() {
      return format(this.date, 'HH:mm:ss (xxx)');
    }
  },

  created() {
    const interval = setInterval(() => {
      this.date = new Date();
    }, 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(interval);
    });
  }
};
</script>

<style lang="less">
.user-time {
  text-transform: uppercase;
  font-weight: 600;
  color: #87919c !important;

  &:hover {
    color: var(--f7-navbar-link-color) !important;
  }
}
</style>
